import columns from './columns';

const data = {
  columns,
};

export default data;
